<template>
  <a
    :href="url"
    :class="[
      $style.base,
      underline ? $style.underline : {},
      color === 'white' ? $style.white : $style.pacificblue
    ]"
    :target="externalValue"
    v-bind="$attrs"
  >
    <slot />
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface LinkProps {
  url?: string
  external?: boolean
  underline?: boolean
  color?: 'pacificblue' | 'white'
}

const {
  url,
  external = false,
  underline = false,
  color = 'pacificblue'
} = defineProps<LinkProps>()

const externalValue = computed(() => {
  return external ? '_blank' : undefined
})
</script>

<style module>
.base {
  text-decoration: none;
  &:hover,
  &:focus-visible {
    text-decoration: underline;
    cursor: pointer;
  }
}

.underline {
  text-decoration: underline;
}

.white {
  color: var(--color-white);
}

.pacificblue {
  color: var(--color-pacificblue);
}
</style>
